// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tC","title":"tD","notSelected":"tE","duration":"tF","image":"tG","infoWrapper":"tH","description":"tI"};